export default "__VITE_ASSET__B2NLX6Ef__"